import React from 'react';

import { Card } from 'react-bootstrap';
import { Link } from 'react-router-dom';

/* Compact one-click shortcuts to every admin area — sits near the top so the
   admin never has to scroll to the bottom to navigate. */
const LINKS = [
  { to: '/admin/products', icon: '📦', label: 'Products' },
  { to: '/admin/orders', icon: '📋', label: 'Orders' },
  { to: '/admin/users', icon: '👥', label: 'Users' },
  { to: '/admin/categories', icon: '📂', label: 'Categories' },
  { to: '/admin/coupons', icon: '🎟️', label: 'Coupons' },
  { to: '/admin/tickets', icon: '🎫', label: 'Tickets' },
  { to: '/admin/refunds', icon: '💰', label: 'Refunds' },
  { to: '/admin/reviews', icon: '⭐', label: 'Reviews' },
  { to: '/admin/delivery-partners', icon: '🛵', label: 'Delivery' },
  { to: '/admin/product-time', icon: '⏱', label: 'Engagement' }
];

function ManagementQuickNav() {
  return (
    <Card className="border-0 shadow-sm mb-5 mqn-card">
      <Card.Body className="p-3 p-md-4">
        <div className="d-flex align-items-center justify-content-between mb-3">
          <h5 className="fw-bold mb-0">⚡ Quick Access</h5>
          <small className="text-muted d-none d-sm-block">
            Jump to any section
          </small>
        </div>

        <div className="mqn-grid">
          {LINKS.map((l) => (
            <Link key={l.to} to={l.to} className="mqn-tile">
              <span className="mqn-icon">{l.icon}</span>
              <span className="mqn-label">{l.label}</span>
            </Link>
          ))}
        </div>
      </Card.Body>

      <style>{mqnStyles}</style>
    </Card>
  );
}

const mqnStyles = `
  .mqn-card {
    border-radius: 20px;
  }
  .mqn-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(96px, 1fr));
    gap: 12px;
  }
  .mqn-tile {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 6px;
    padding: 14px 8px;
    border-radius: 16px;
    text-decoration: none;
    color: #7c2d12;
    background: #fff7ed;
    border: 1px solid #fed7aa;
    transition: transform 0.2s ease, box-shadow 0.2s ease, background 0.2s ease;
  }
  .mqn-tile:hover {
    transform: translateY(-4px);
    background: #ffedd5;
    box-shadow: 0 12px 22px rgba(234, 88, 12, 0.18);
    color: #7c2d12;
  }
  .mqn-icon {
    font-size: 1.7rem;
    line-height: 1;
  }
  .mqn-label {
    font-size: 0.82rem;
    font-weight: 700;
    text-align: center;
  }

  @media (max-width: 575.98px) {
    .mqn-grid {
      grid-template-columns: repeat(auto-fill, minmax(78px, 1fr));
      gap: 10px;
    }
    .mqn-icon { font-size: 1.4rem; }
    .mqn-label { font-size: 0.72rem; }
  }
`;

export default ManagementQuickNav;
